module.exports = __webpack_public_path__ + "assets/img/3201.012d37ea.png";